import { useCheckPermission } from 'app/hooks/useCheckPermission'
import { useFeatureToggle } from 'app/hooks/useFeatureToggle'
import { hasRole, useUser } from 'app/utils'
import { isSMCOrg } from 'lib/isSMCOrg'

export function useAddMarketingColumns(): boolean {
  const me = useUser()
  const staffV2Enabled = useFeatureToggle(`staff-v2`)
  const checkPermission = useCheckPermission()

  if (!me) return false
  if (staffV2Enabled) {
    return me.type === `super` || checkPermission(`org:marketing:advanced-filters`)
  }

  const isSMC = isSMCOrg(me.orgId!)
  const isSuper = me.type === `super`
  return isSuper || (isSMC && hasRole(me, `orgAdmin`)) || (!isSMC && !hasRole(me, `orgAssistant`))
}
